import en from 'dayjs/locale/en'

const locale: ILocale = {
  ...en,
  name: 'en',
  weekdays: 'sunday_monday_tuesday_wednesday_thursday_friday_saturday'.split('_'),
  weekStart: 1,
  weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
  monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
  weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
  ordinal: (n) => n
}

export default locale
